import { useState } from 'react'
import { Download } from 'lucide-react'
import { useConfigureGatewayLinkMutation } from '@axilon-apps/domains-ontology-ui-state'
import { Button } from '../../../components/ui/button'

export function GatewayLinkSetup({
  gatewayUrl,
  fields,
  siteId
}: {
  gatewayUrl: string
  fields: Record<string, string>
  siteId: string
}) {
  const [configure, { isLoading }] = useConfigureGatewayLinkMutation()
  const [error, setError] = useState('')
  const [downloaded, setDownloaded] = useState(false)
  return (
    <div className="grid gap-2">
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="w-fit"
        disabled={
          isLoading ||
          !gatewayUrl.trim() ||
          !fields.gatewayLinkCertificate?.trim() ||
          !siteId ||
          siteId === '*'
        }
        onClick={async () => {
          setError('')
          setDownloaded(false)
          try {
            const setup = await configure({
              gatewayUrl,
              certificate: fields.gatewayLinkCertificate,
              gatewayId: fields.gatewayLinkGatewayId,
              siteId
            }).unwrap()
            const url = URL.createObjectURL(
              new Blob([JSON.stringify(setup, null, 2)], { type: 'application/json' })
            )
            const anchor = document.createElement('a')
            anchor.href = url
            anchor.download = 'gateway-link-connection.json'
            anchor.click()
            URL.revokeObjectURL(url)
            setDownloaded(true)
          } catch {
            setError(
              'Could not prepare Gateway Link. Check administrator access, the selected site, and the proxy’s public listener URL and secret store configuration.'
            )
          }
        }}
      >
        <Download /> {isLoading ? 'Preparing connection…' : 'Download gateway connection settings'}
      </Button>
      <p className="text-xs text-ink-muted">
        Install this public connection file in the Gateway Link module’s configuration directory and
        restart the module before continuing ingest. Private keys stay on the proxy and gateway.
      </p>
      {downloaded && (
        <p role="status" className="text-xs text-ink-muted">
          Connection settings downloaded. The module will connect after installation and restart.
        </p>
      )}
      {error && (
        <p role="alert" className="text-xs text-st-error">
          {error}
        </p>
      )}
    </div>
  )
}
